import { useMutation } from "react-query";
import { toast } from "react-toastify";

import { fetchPublicIp } from "@/api/infrastructure/fetch-public-ip";
import { grantSqlAccess } from "@/api/infrastructure/sql-access-api";

export const grantSqlAccessKey = "grant-sql-access";

export function useGrantSqlAccess() {
	return useMutation(
		async () => {
			const clientIp = await fetchPublicIp();
			return grantSqlAccess(clientIp);
		},
		{
			onSuccess: (response) => {
				const securityGroups = (response?.updates || []).map((item) => item.security_group_id).join(", ");
				const groupsSuffix = securityGroups ? ` (${securityGroups})` : "";

				toast.success(`Acceso SQL habilitado para ${response.client_ip}${groupsSuffix}`);
			},
			onError: (error) => {
				const message =
					error?.response?.data?.error ||
					error?.response?.data?.data ||
					error?.message ||
					"No se pudo actualizar el security group. Verifique la configuración en AWS.";

				toast.error(message);
			},
		},
	);
}
